"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AVERAGE_CALCULATION = (values) => {
    let sum = 0;
    for (const val of values) {
        sum += val;
    }
    return sum / values.length;
};
exports.SUM_CALCULATION = (values) => {
    let sum = 0;
    for (const val of values) {
        sum += val;
    }
    return sum;
};
class Profiler {
    constructor(name, calculation, sampleSize = 100) {
        this.name = name;
        this.sampleSize = sampleSize;
        this.calculationHandler = calculation;
        this.currentSamples = 0;
        this.samples = [];
    }
    onProfile(handler) {
        this.profileHandler = handler;
    }
    onSample(handler) {
        this.sampleHandler = handler;
    }
    sample(val) {
        if (this.sampleHandler)
            this.sampleHandler(val);
        this.samples.push(val);
        this.currentSamples++;
        if (this.currentSamples >= this.sampleSize) {
            if (this.profileHandler)
                this.profileHandler(this.calculationHandler(this.samples));
            this.samples = [];
            this.currentSamples = 0;
        }
    }
}
exports.Profiler = Profiler;
